import type { ITokenResult } from "@/data/model/Authorization";
import { config } from "@/data/util/Config";

import { logInformation } from "@/shared/logging/informations";

export class ExternalLogin {
    private static popup?: Window;

    public static loginWithProvider(provider: string): Promise<ITokenResult> {
        ExternalLogin.closePopup();

        return new Promise((resolve, reject) => {
            if (provider !== "facebook" && provider !== "google" && provider !== "linkedin") {
                reject(new Error(provider + " is not supported"));
                return;
            }

            $(window)
                .unbind("message.externallogin")
                .bind("message.externallogin", (e) => {
                    ExternalLogin.closePopup();
                    if (e.originalEvent["data"] !== undefined) {
                        const data = e.originalEvent["data"];
                        if (data.success === true && data["tokenResult"] !== undefined) {
                            logInformation("external login success!!! ");
                            logInformation("Token: " + data["tokenResult"]);
                            resolve(data["tokenResult"]);
                            return;
                        }
                    }

                    logInformation("External login didn't work :(");
                    reject(new Error("External authorization failed."));
                });

            if (config.isMockClient)
                ExternalLogin.popup = window.open("externalloginconfirm.html", "", "width=980,height=870") ?? undefined;
            else ExternalLogin.popup = window.open("/signin/" + provider, "", "width=980,height=870") ?? undefined;
        });
    }

    private static closePopup() {
        $(window).unbind("message.externallogin");
        if (ExternalLogin.popup !== undefined && ExternalLogin.popup != null) {
            ExternalLogin.popup.close();
            ExternalLogin.popup = undefined;
        }
    }
}
